module.exports = __webpack_public_path__ + "static/img/4.417facf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/clix/4.png
// module id = Of2W
// module chunks = 35